import FirebaseClient from "firebase"

FirebaseClient.initializeApp(
  {
    apiKey: "AIzaSyB-u_9YZ2RbIcwi6BOf3p0AAZRqnFyDs0E",
    authDomain: "patagonia-51e02.firebaseapp.com",
    databaseURL: "https://patagonia-51e02.firebaseio.com",
    projectId: "patagonia-51e02",
    storageBucket: "patagonia-51e02.appspot.com",
    messagingSenderId: "107897007362"
  }
)

export default FirebaseClient



// WEBPACK FOOTER //
// ./src/services/Firebase/index.js